import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSEO } from "@/hooks/useSEO";

const Terms = () => {
  useSEO({
    title: "Terms of Service | Loch Ness Story",
    description: "Terms of service for Loch Ness Story. Read the rules and guidelines for using our website.",
    canonical: "/terms",
  });
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Navbar />
      <main className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose prose-invert max-w-none">
          <p className="mb-6">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p>By accessing and using Loch Ness Story, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. User Accounts</h2>
            <p>To use certain features of our service, you must register for an account. You agree to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide accurate information</li>
              <li>Maintain the security of your account</li>
              <li>Notify us immediately of any unauthorized access</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Content Guidelines</h2>
            <p>When submitting sighting reports, you agree to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide accurate information to the best of your knowledge</li>
              <li>Respect the privacy and rights of others</li>
              <li>Not submit false or misleading reports</li>
              <li>Not upload harmful or malicious content</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Termination</h2>
            <p>We reserve the right to terminate or suspend access to our service immediately, without prior notice, for any violation of these Terms.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;